import { defineStyleConfig } from "@chakra-ui/react";

export const spinnerTheme = defineStyleConfig({
	baseStyle: {
		color: "neutrals.200",
	},
	sizes: {
		xs: {
			width: "8px",
			height: "8px",
		},
		sm: {
			width: "16px",
			height: "16px",
		},
		md: {
			width: "24px",
			height: "24px",
		},
		lg: {
			width: "40px",
			height: "40px",
		},
	},
	defaultProps: {
		size: "sm",
	},
});
